import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=70c9ea70&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=70c9ea70&prod&lang=scss&scoped=true&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=70c9ea70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9ea70",
  null
  
)

export default component.exports